export class RecipientInfo {
  email: string;

  constructor(info?: any) {
    info = info || {};
    this.email = info.email || null;
  }
}
